export default __webpack_public_path__ + "static/media/shutterstock_62766982.a4c8dae0.jpg";